import { isAuthorPlanUtil } from '../is-author'
import isOwnerModelUtil from '../../../../../models/utils/is-owner'

function canEditPlanUtil (plan, profile) {
  return (
    isAuthorPlanUtil(plan, profile) ||
    isOwnerModelUtil(plan, profile)
  )
}

export {
  canEditPlanUtil
}
